var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-btn date-btn"},[_c('span',[_vm._v(_vm._s(_vm.day))]),_c('span',{staticClass:"date-delimiter"},[_vm._v(_vm._s(_vm.weekday))]),_c('span',[_vm._v(_vm._s(_vm.hour)+_vm._s(_vm.colon)+_vm._s(_vm.minutes))])])
}
var staticRenderFns = []

export { render, staticRenderFns }